import MyProfile from 'views/Social/MyProfile'

const Page = () => <MyProfile />
Page.chains = []

export default Page
